<!-- From sm up: three cards, each with its name and example; each card spans two rows of this grid via subgrid, so the
     examples line up even when only some names wrap. Below sm the same radios become a three-way switch of short names,
     with the chosen type's example under it (MP-11329), so all three fit across a small phone. -->
<div
  class="tw-grid tw-grid-cols-3 tw-gap-1 tw-rounded-xl tw-bg-slate-100 tw-p-1 sm:tw-gap-x-2 sm:tw-gap-y-1 sm:tw-rounded-none sm:tw-bg-transparent sm:tw-p-0"
  role="radiogroup"
  [attr.aria-labelledby]="labelledBy()"
  [attr.aria-label]="labelledBy() ? null : 'Payment type'"
  data-testid="payment-type-cards"
  #group>
  @for (card of cards; track card.type; let i = $index) {
    <button
      type="button"
      role="radio"
      class="tw-relative tw-flex tw-min-h-[44px] tw-cursor-pointer tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-rounded-[9px] tw-border tw-border-solid tw-px-1 tw-py-1.5 tw-text-center disabled:tw-cursor-not-allowed disabled:tw-opacity-60 sm:tw-row-span-2 sm:tw-grid sm:tw-grid-rows-subgrid sm:tw-items-stretch sm:tw-justify-start sm:tw-rounded-[10px] sm:tw-bg-white sm:tw-px-3.5 sm:tw-py-3 sm:tw-text-left"
      [class]="
        value() === card.type
          ? 'tw-border-brand-maroon tw-bg-white tw-shadow-sm sm:tw-shadow-none sm:tw-ring-[3px] sm:tw-ring-[#ffeef4]'
          : 'tw-border-transparent tw-bg-transparent sm:tw-border-slate-200 sm:hover:tw-border-slate-300'
      "
      [attr.aria-checked]="value() === card.type"
      [attr.tabindex]="tabIndexFor(card.type, i)"
      [attr.data-testid]="'payment-type-card-' + card.type"
      [disabled]="disabled()"
      (click)="choose(card.type)"
      (keydown)="onKeydown($event, i, group)">
      <!-- On phones the full name and example stay in the radio for screen readers; the short name and the line under
           the switch are visual only. -->
      <span
        aria-hidden="true"
        class="tw-text-sm tw-font-extrabold tw-leading-tight sm:tw-hidden"
        [class]="value() === card.type ? 'tw-text-brand-maroon' : 'tw-text-slate-700'"
        data-testid="payment-type-card-short-name"
        >{{ card.shortName }}</span
      >
      <span class="tw-sr-only tw-text-[15px] tw-font-bold tw-text-slate-800 sm:tw-not-sr-only" data-testid="payment-type-card-name">{{
        card.name
      }}</span>
      <span class="tw-sr-only tw-text-[13px] tw-leading-snug tw-text-slate-600 sm:tw-not-sr-only" data-testid="payment-type-card-example">{{
        card.example
      }}</span>
    </button>
  }
</div>
@if (chosenExample) {
  <p aria-hidden="true" class="tw-mb-0 tw-mt-2 tw-text-[13px] tw-text-slate-600 sm:tw-hidden" data-testid="payment-type-hint">{{ chosenExample }}</p>
}
